<template>
  <div class="forum-detail">
    <div class="content-width">
      <el-row>
        <el-col :span="18">
          <el-row>
            <el-col :span="16">
              <span class="large-title">{{ name }}</span>
              <span class="browse-count">浏览量：{{ llCount }}</span>
            </el-col>
            <el-col :span="8" class="btn-group">
              <el-button
                size="small"
                icon="el-icon-star-on"
                class="btn1"
                :class="isCollection ? 'red' : 'grey'"
                @click="collectPer()"
                >收藏</el-button
              >
              <el-button
                size="small"
                icon="el-icon-share"
                class="btn1 grey"
                @click="shareF()"
                >分享</el-button
              >
              <div>
                <share
                  :config="config1"
                  style="display:inline-block"
                  v-if="isShare"
                ></share>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="jiangshi">
              <span>讲师：{{ author }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="text-align:center">
              <img :src="$store.state.imgUrl+stanceImg" alt="" style="width:80%" />
            </el-col>
          </el-row>

          <el-col :span="24">
            <div class="prescription">简述</div>
          </el-col>
          <el-col :span="24">
            <div class="detailed-description">{{ jianshu }}</div>
          </el-col>
          <el-col :span="24">
            <div class="prescription">详细描述</div>
          </el-col>
          <el-col :span="24">
            <div class="detailed-description">{{ xxms }}</div>
          </el-col>
          <el-row>
            <el-col :span="18">
              <div class="prescription">关联药膳配方</div>
            </el-col>
            <el-col :span="6">
              <div class="buy-car shou" @click="addCar()">购药</div>
            </el-col>
          </el-row>
          <el-table
            :data="prescriptionSlaves"
            style="width: 100%;margin:20px 0px;"
            class="yaoTable"
          >
            <el-table-column :label="prescriptionName" align="center" class="">
              <el-table-column
                prop="medicineName"
                label="中草药名称"
              ></el-table-column>
              <el-table-column prop="dosage" label="剂量"></el-table-column>
              <el-table-column prop="unit" label="单位"></el-table-column>
              <el-table-column prop="year" label="年代"></el-table-column>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:60px">
            <el-col :span="24">
              <el-input
                placeholder="我也来评论一下..."
                v-model="commentText"
                class="input-with-select fabu-reverse comment-button-padding-j"
              >
                <template slot="append">
                  <span class="release-btn shou" @click="fabuComment()"
                    >发布</span
                  >
                </template>
              </el-input>
            </el-col>
          </el-row>
          <el-row class="jcomment">
            <el-col :span="20">
              <div class="prescription">评论</div>
            </el-col>
            <el-col :span="4">
              <div class="comment-count">（{{ commentTotal }}条）</div>
            </el-col>
          </el-row>
          <!--评论  -->
          <el-row
            class="jcomment-list"
            v-for="(item, index) in commentList"
            :key="index"
          >
            <!-- 评论内容 -->
            <el-row>
              <el-col :span="2">
                <img :src="$store.state.imgUrl+item.headImg" alt class="head-img" />
              </el-col>
              <el-col :span="20" class="common-list">
                <div>
                  {{ item.username }}
                  <span class="commentime">{{ item.createDate }}</span>
                </div>
                <div class="jcomment-content">{{ item.commentText }}</div>
              </el-col>
              <!-- <el-col :span="2">
                                <img
                                    src="../assets/img/34.png"
                                    alt
                                    class="resver"
                                    @click="item.commentRever =true"
                                />
                            </el-col>-->
            </el-row>
            <!-- 回复评论内容 -->
            <!-- <el-row class="jcomment-list reverse-jcomment-list">
                                <el-col :span="2">
                                    <img src="../assets/img/39.png" alt class="head-img" />
                                </el-col>
                                <el-col :span="20" class="common-list">
                                    <div>
                                        浩天哲
                                        <span class="commentime">2019-07-11 09:20</span>
                                    </div>
                                    <div class="jcomment-content">
                                        回复
                                        <span class="reverse-name">医师</span>:讲的很好，从中学到了很多小窍门，以后有时间还会接着观看，中医还是很强大啊！！！
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <img src="../assets/img/34.png" alt class="resver" />
                                </el-col>
                                <el-row>
                                    <el-col :span="24">
                                        <el-input
                                            placeholder="我也来评论一下..."
                                            v-model="comment"
                                            class="input-with-select fabu-reverse reverse-comment comment-button-padding-j"
                                        >
                                            <template slot="append">
                                                <span class="release-btn">回复</span>
                                            </template>
                                        </el-input>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col class="inner-comment-view-more">
                                        查看更多回复
                                        <i class="el-icon-d-arrow-right"></i>
                                    </el-col>
                                </el-row>
                        </el-row>-->

            <el-row v-if="item.commentRever">
              <el-col :span="24">
                <el-input
                  placeholder="我也来评论一下..."
                  v-model="comment"
                  class="input-with-select fabu-reverse reverse-comment comment-button-padding-j"
                >
                  <template slot="append">
                    <span class="release-btn" @click="item.commentRever = false"
                      >回复</span
                    >
                  </template>
                </el-input>
              </el-col>
            </el-row>
          </el-row>
          <!-- 查看更多 -->
          <el-row class="center-more">
            <el-col :span="24">
              <div
                class="view-more"
                @click="moreDate()"
                v-if="
                  commentList.length > 0 && commentTotal != commentList.length
                "
              >
                查看更多
              </div>
              <div
                class="view-more"
                v-if="commentList.length <= 0"
                style="border:none"
              >
                暂无评论
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="6" style="width:23%; margin-left: 2%;">
          <el-row>
            <el-col :span="24" class="adv-wrap">
              <div
                class="common-img-outer setPositon listdetail-adver-outer-img"
                v-for="(item, index) in jingtangAdverList"
                :key="index"
              >
                <a :href="item.urlLink">
                  <img :src="$store.state.imgUrl+item.urlImage" alt style="width:100%" />
                  <span class="adver-words-tip" v-if="item.urlImage">{{
                    adverWordsTip
                  }}</span>
                </a>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="contain"></div>
  </div>
</template>

<script>
export default {
  name: "ForumDetail",
  data() {
    return {
      commentText: "", //评论内容
      prescriptionSlaves: [], //关联药膳配方
      id: "",
      prescription: "", //处方id
      name: "", //图文名
      llCount: "", //浏览数
      author: "",
      prescriptionName: "",
      jianshu: "",
      xxms: "",
      collectionId: "",
      stanceImg: "" //图片占位图
    };
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    // 收藏和取消收藏
    collectPer() {
      let that = this;
      if (that.isCollection) {
        //已经收藏了
        that.unCollect(that.id, 3);
      } else {
        //还没收藏呢
        that.collect(that.id, 3);
      }
    },
    //获取详情
    async getDetail(id) {
      let that = this;
      if (sessionStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      let url = "/medicineForum/getMedicineForumTuwenByDetail";
      let parmas = {
        id: id,
        userId: that.userInfo.id
      };
      await that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.id = arr.id;
            that.name = arr.name;
            that.commentList = [];
            that.commentPageInfo.pageNum = 1;
            that.getAllComment(that.id); //获取全部评论
            that.prescription = arr.prescription;
            that.llCount = arr.llCount;
            that.author = arr.author;
            that.prescriptionName = arr.prescriptionName;
            that.stanceImg = arr.stanceImg;
            that.jianshu = arr.jianshu;
            that.xxms = arr.xxms;
            that.collectionId = arr.collectionId;
            if (!!that.collectionId) {
              // 收藏了
              that.isCollection = true;
            } else {
              //没收藏
              that.isCollection = false;
            }
            that.prescriptionSlaves = arr.prescriptionSlaves.map(
              (item, index) => {
                return {
                  dosage: item.dosage,
                  unit: item.unit,
                  medicineName: item.medicineName,
                  year: arr.year
                };
              }
            );
            //  if (!!arr.authorizeStopTime) {
            //     if (that.changeChuo(that.getTime(arr.authorizeStopTime)) < Date.now()) {
            //         console.log("过期了");
            //     }
            // }
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //加入购物车
    addCar() {
      let that = this;
      if (!that.isLoginF() || !this.prescriptionSlaves.length) return false;
      //立即购买
      this.$router.push({
        path: "/ReceivingAddress2",
        query: { id: that.prescription }
      });
    },
    //发布评论
    fabuComment() {
      let that = this;
      if (!that.commentText) {
        that.$message.error("请您输入评论内容");
        return false;
      }
      that.addComment(that.id, that.name, that.commentText).then(res => {
        that.commentPageInfo.pageNum = 1;
        that.commentList = [];
        that.getAllComment(that.id);
        that.commentText = "";
      });
    },
    //查看更多数据
    moreDate() {
      let that = this;
      that.commentPageInfo.pageNum++;
      that.getAllComment(that.id);
    }
  },
  created() {
    let that = this;
    that.getPositionAdver(2, 3);
    if (!!that.$route.query.id) {
      that.id = that.$route.query.id;
      that.getDetail(that.id); //获取详情
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.forum-detail .btn-group {
  text-align: right;
}
.forum-detail .btn-group .el-button {
  width: 100px;
  height: 44px;
  font-family: MicrosoftYaHei;
  background-color: #ababab;
  color: white;
  font-size: 18px;
  color: #ffffff;
}

.adv-list {
  padding: 10px;
}
.common-row {
  border-top: 1px solid #dddddd;
  margin-top: 30px;
}
.resver {
  /* margin-top: 25px; */
  float: right;
}
.head-img {
  /* margin-top: 16px; */
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.common-list {
  font-size: 16px;
  /* line-height: 42px; */
  color: #303030;
}
.common-list span {
  font-size: 14px;
  color: #666666;
}
.comment-count {
  font-size: 16px;
  text-align: right;
  letter-spacing: 0px;
  color: #666666;
}
.input-with-select {
  background-color: #f9f9f9;
  border: 1px solid #dcdfe6;
  /* margin: 60px auto 30px; */
}
.release-btn {
  width: 50px;
  display: block;
  height: 24px;
  line-height: 24px;
  background-color: #f64420;
  border-radius: 16px;
  color: white;
  text-align: center;
}

.detailed-description {
  font-size: 16px;
  text-align: justify;
  line-height: 36px;
  letter-spacing: 1.6px;
  color: #666666;
}
thead .cell {
  text-align: center;
}
.buy-car {
  width: 120px;
  height: 32px;
  background-color: #f64420;
  border-radius: 16px;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 1.6px;
  color: #ffffff;
  text-align: center;
  float: right;
}
.prescription {
  font-size: 22px;
  line-height: 36px;
  letter-spacing: 2.2px;
  color: #333333;
}

.collection-button {
  width: 300px;
  height: 52px;
  background-color: #f87461;
  font-size: 16px;
  line-height: 52px;
  letter-spacing: 1.6px;
  color: #ffffff;
  text-align: center;
  margin: 0px auto;
  cursor: pointer;
}
.comment-button {
  width: 120px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 16px;

  font-size: 16px;
  line-height: 36px;
  margin-top: 14px;
  letter-spacing: 1.6px;
  color: #ffffff;
  float: right;
}
.comment-button span {
  letter-spacing: 1.6px;
  color: #ffffff;
  opacity: 0.5;
  display: block;
  text-align: center;
}
.lecturer {
  font-size: 16px;
  line-height: 56px;
  letter-spacing: 1.6px;
  color: #ffffff;
}
.collection-name {
  font-size: 24px;
  line-height: 50px;
  letter-spacing: 2.4px;
  color: #f95809;
}
.jianshu-word {
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 1.4px;
  color: #808080;
  text-align: justify;
  padding: 0px 15px;
}
.jianshu {
  font-size: 18px;
  line-height: 50px;
  letter-spacing: 1.8px;
  color: #ffffff;
  text-align: left;
}
.collection {
  text-align: center;
}
.collection-list .el-button {
  background-color: transparent;
  border: none;
  color: white;
  margin-left: 16px;
  line-height: 30px;
}
.video-box {
  width: 100%;
  padding: 20px 0px;
  background-color: #333333;
}
.video-title {
  font-size: 18px;
  line-height: 50px;
  letter-spacing: 1.8px;
  color: #ffffff;
  text-align: left;
}
.collection-count {
  float: right;
  font-size: 14px;
  line-height: 50px;
  letter-spacing: 1.4px;
  color: #ffffff;
  opacity: 0.3;
}
.video-line {
  width: 100%;
  height: 1px;
  background-color: #ffffff;
  opacity: 0.1;
}
/* .el-button+.el-button{
  margin-left: 5px;
} */
.collection .el-button {
  background: transparent;
  border: none;
  color: #e3e3e3;
  margin-left: 5px;
}
.collection .el-button--mini,
.el-button--mini.is-round {
  padding: 14px 10px;
}
/* .input-with-select .el-input-group__append{
    padding: 0px;
} */
</style>
<style>
.yaoTable th,
.yaoTable td {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ForumDetailw.vue